enum Criterion {
  OCCLUSION_MOLAR_CLASS = "OCCLUSION_MOLAR_CLASS",
  OCCLUSION_CUSPID_CLASS = "OCCLUSION_CUSPID_CLASS",
  OCCLUSION_OVERBITE_CLASS = "OCCLUSION_OVERBITE_CLASS",
  OCCLUSION_OVERBITE_CLASS_V2 = "OCCLUSION_OVERBITE_CLASS_V2",
  OCCLUSION_POSTERIOR_OPEN_BITE_CLASS = "OCCLUSION_POSTERIOR_OPEN_BITE_CLASS",
  OCCLUSION_OVERJET_CLASS = "OCCLUSION_OVERJET_CLASS",
  OCCLUSION_OVERJET_CLASS_V2 = "OCCLUSION_OVERJET_CLASS_V2",
  OCCLUSION_SEGMENTAL_LINGUAL_CROSSBITE_CLASS = "OCCLUSION_SEGMENTAL_LINGUAL_CROSSBITE_CLASS",
  OCCLUSION_CROSSBITE_CLASS_V2 = "OCCLUSION_CROSSBITE_CLASS_V2",
  OCCLUSION_TOTAL_BUCAL_CROSSBITE_CLASS = "OCCLUSION_TOTAL_BUCAL_CROSSBITE_CLASS",
  CROWDING_UPPER_ANTERIOR = "CROWDING_UPPER_ANTERIOR",
  CROWDING_UPPER_POSTERIOR = "CROWDING_UPPER_POSTERIOR",
  CROWDING_UPPER = "CROWDING_UPPER",
  CROWDING_LOWER_ANTERIOR = "CROWDING_LOWER_ANTERIOR",
  CROWDING_LOWER_POSTERIOR = "CROWDING_LOWER_POSTERIOR",
  CROWDING_LOWER = "CROWDING_LOWER",
  SPACING_UPPER_ANTERIOR = "SPACING_UPPER_ANTERIOR",
  SPACING_LOWER_ANTERIOR = "SPACING_LOWER_ANTERIOR",
  DENTITION_CARIES = "DENTITION_CARIES",
  DENTITION_TOOTH_DECAY = "DENTITION_TOOTH_DECAY",
  DENTITION_STAINED_FISSURES_PITS = "DENTITION_STAINED_FISSURES_PITS",
  DENTITION_MISSING_PERMANENT_TEETH = "DENTITION_MISSING_PERMANENT_TEETH",
  DENTITION_MISSING_PERMANENT_TEETH_V2 = "DENTITION_MISSING_PERMANENT_TEETH_V2",
  DENTITION_FRACTURED = "DENTITION_FRACTURED",
  DENTITION_RETAINED_DECIDUOUS_TEETH = "DENTITION_RETAINED_DECIDUOUS_TEETH",
  DENTITION_RETAINED_DECIDUOUS_TEETH_V2 = "DENTITION_RETAINED_DECIDUOUS_TEETH_V2",
  DENTITION_PEG_SHAPED_LATERAL_INCISORS = "DENTITION_PEG_SHAPED_LATERAL_INCISORS",
  DENTITION_PEG_SHAPED_LATERAL_INCISORS_V2 = "DENTITION_PEG_SHAPED_LATERAL_INCISORS_V2",
  DENTITION_ABRASION = "DENTITION_ABRASION",
  DENTITION_ANTERIOR_ATTRITION = "DENTITION_ANTERIOR_ATTRITION",
  DENTITION_WHITENING_NEED = "DENTITION_WHITENING_NEED",
  DENTITION_CUSPID_TEETH_ROTATION = "DENTITION_CUSPID_TEETH_ROTATION",
  DENTITION_INCISOR_TEETH_ROTATION = "DENTITION_INCISOR_TEETH_ROTATION",
  PERIODONTAL_ORAL_HYGIENE = "PERIODONTAL_ORAL_HYGIENE",
  PERIODONTAL_ORAL_HYGIENE_V2 = "PERIODONTAL_ORAL_HYGIENE_V2",
  PERIODONTAL_GINGIVAL_CONDITION = "PERIODONTAL_GINGIVAL_CONDITION",
  PERIODONTAL_GINGIVITIS = "PERIODONTAL_GINGIVITIS",
  PERIODONTAL_GENERALISED_RECESSION = "PERIODONTAL_GENERALISED_RECESSION",
  PERIODONTAL_LOCALISED_RECESSION = "PERIODONTAL_LOCALISED_RECESSION",
  PERIODONTAL_RECESSION = "PERIODONTAL_RECESSION",
  PERIODONTAL_FRENUM = "PERIODONTAL_FRENUM",
}

export function getI18NKey(criterion: Criterion) {
  switch (criterion) {
    case Criterion.OCCLUSION_MOLAR_CLASS:
      return "Criterion.Orthodontics.Occlusion.MolarClass";
    case Criterion.OCCLUSION_CUSPID_CLASS:
      return "Criterion.Orthodontics.Occlusion.CuspidClass";
    case Criterion.OCCLUSION_OVERBITE_CLASS:
      return "Criterion.Orthodontics.Occlusion.OverbiteClass";
    case Criterion.OCCLUSION_OVERBITE_CLASS_V2:
      return "Criterion.Orthodontics.Occlusion.OverbiteClassV2";
    case Criterion.OCCLUSION_POSTERIOR_OPEN_BITE_CLASS:
      return "Criterion.Orthodontics.Occlusion.PosteriorOpenBiteClass";
    case Criterion.OCCLUSION_OVERJET_CLASS:
      return "Criterion.Orthodontics.Occlusion.OverjetClass";
    case Criterion.OCCLUSION_OVERJET_CLASS_V2:
      return "Criterion.Orthodontics.Occlusion.OverjetClassV2";
    case Criterion.OCCLUSION_SEGMENTAL_LINGUAL_CROSSBITE_CLASS:
      return "Criterion.Orthodontics.Occlusion.SegmentalLingualCrossbiteClass";
    case Criterion.OCCLUSION_CROSSBITE_CLASS_V2:
      return "Criterion.Orthodontics.Occlusion.CrossbiteClassV2";
    case Criterion.OCCLUSION_TOTAL_BUCAL_CROSSBITE_CLASS:
      return "Criterion.Orthodontics.Occlusion.TotalBuccalCrossbiteClass";
    case Criterion.CROWDING_UPPER_ANTERIOR:
      return "Criterion.Orthodontics.Crowding.UpperAnterior";
    case Criterion.CROWDING_UPPER_POSTERIOR:
      return "Criterion.Orthodontics.Crowding.UpperPosterior";
    case Criterion.CROWDING_UPPER:
      return "Criterion.Orthodontics.Crowding.Upper";
    case Criterion.CROWDING_LOWER_ANTERIOR:
      return "Criterion.Orthodontics.Crowding.LowerAnterior";
    case Criterion.CROWDING_LOWER_POSTERIOR:
      return "Criterion.Orthodontics.Crowding.LowerPosterior";
    case Criterion.CROWDING_LOWER:
      return "Criterion.Orthodontics.Crowding.Lower";
    case Criterion.SPACING_UPPER_ANTERIOR:
      return "Criterion.Orthodontics.Spacing.UpperAnterior";
    case Criterion.SPACING_LOWER_ANTERIOR:
      return "Criterion.Orthodontics.Spacing.LowerAnterior";
    case Criterion.DENTITION_CARIES:
      return "Criterion.Dentition.Caries";
    case Criterion.DENTITION_TOOTH_DECAY:
      return "Criterion.Dentition.ToothDecay";
    case Criterion.DENTITION_STAINED_FISSURES_PITS:
      return "Criterion.Dentition.StainedFissuresPits";
    case Criterion.DENTITION_MISSING_PERMANENT_TEETH:
      return "Criterion.Dentition.MissingPermanentTeeth";
    case Criterion.DENTITION_MISSING_PERMANENT_TEETH_V2:
      return "Criterion.Dentition.MissingPermanentTeeth";
    case Criterion.DENTITION_FRACTURED:
      return "Criterion.Dentition.Fractured";
    case Criterion.DENTITION_RETAINED_DECIDUOUS_TEETH:
      return "Criterion.Dentition.RetainedDeciduousTeeth";
    case Criterion.DENTITION_RETAINED_DECIDUOUS_TEETH_V2:
      return "Criterion.Dentition.RetainedDeciduousTeethV2";
    case Criterion.DENTITION_PEG_SHAPED_LATERAL_INCISORS:
      return "Criterion.Dentition.PegShapedLateralIncisors";
    case Criterion.DENTITION_PEG_SHAPED_LATERAL_INCISORS_V2:
      return "Criterion.Dentition.PegShapedLateralIncisorsV2";
    case Criterion.DENTITION_ABRASION:
      return "Criterion.Dentition.Abrasion";
    case Criterion.DENTITION_ANTERIOR_ATTRITION:
      return "Criterion.Dentition.AnteriorAttrition";
    case Criterion.DENTITION_WHITENING_NEED:
      return "Criterion.Dentition.WhiteningNeed";
    case Criterion.DENTITION_CUSPID_TEETH_ROTATION:
      return "Criterion.Orthodontics.Rotation.CuspidTeethRotation";
    case Criterion.DENTITION_INCISOR_TEETH_ROTATION:
      return "Criterion.Orthodontics.Rotation.IncisorTeethRotation";
    case Criterion.PERIODONTAL_ORAL_HYGIENE:
      return "Criterion.Periodontal.OralHygiene";
    case Criterion.PERIODONTAL_ORAL_HYGIENE_V2:
      return "Criterion.Periodontal.OralHygieneV2";
    case Criterion.PERIODONTAL_GINGIVAL_CONDITION:
      return "Criterion.Periodontal.GingivalCondition";
    case Criterion.PERIODONTAL_GINGIVITIS:
      return "Criterion.Periodontal.Gingivitis";
    case Criterion.PERIODONTAL_GENERALISED_RECESSION:
      return "Criterion.Periodontal.GeneralisedRecession";
    case Criterion.PERIODONTAL_LOCALISED_RECESSION:
      return "Criterion.Periodontal.LocalisedRecession";
    case Criterion.PERIODONTAL_RECESSION:
      return "Criterion.Periodontal.Recession";
    case Criterion.PERIODONTAL_FRENUM:
      return "Criterion.Periodontal.Frenum";
  }
}

export default Criterion;
